export default {
  setAttendances(state, data) {
    state.attendances = data;
  },

  clearAttendances(state) {
    state.attendances = [];
  },
};
